// extracted by mini-css-extract-plugin
var _1 = "OGIiusj4elyZEMsvzQP7";
var _2 = "suJjw6b9cTPaLrcd0Zdg";
var _3 = "_lk5JC59NMTNcFqrze4J";
var _4 = "eSkz1rEmdJP2NWz93cgN";
var _5 = "hMLNcfGqrTRjZv1XUUzi";
var _6 = "e4w8SIbWFdyQtHEqwljQ";
var _7 = "yK1K4QxfvN50d3HmjFk2";
var _8 = "XDgNdIxYTFwnMXkBvX9p";
var _9 = "Ylcd3ZZSsrE7liPVQ5TD";
var _a = "b_uEHpy62QUXorTVsmvd";
var _b = "H6FHaXAtHi3hUouumyb0";
var _c = "IMAxfYD6PXz00RJc1Nua";
var _d = "C8diEJWVdQx7ceTz5uyA";
var _e = "I5itWn3KJZ6ux__UmqQu";
var _f = "mrH8rja1EBxs1y6JuEKZ";
var _10 = "mICnDeHqSWhnBYw9akdG";
var _11 = "oMUO5u2fmjike19cKFK9";
var _12 = "obGQImaKrHwlNn3jdIJ7";
var _13 = "fkVxUgCp6iqIeLWXXZPX";
export { _1 as "iconButton", _2 as "is-128x128", _3 as "is-16x16", _4 as "is-24x24", _5 as "is-32x32", _6 as "is-48x48", _7 as "is-64x64", _8 as "is-96x96", _9 as "theme-cardiology", _a as "theme-dermatology", _b as "theme-empty", _c as "theme-lab", _d as "theme-mentalHealth", _e as "theme-ophthalmology", _f as "theme-pulmonology", _10 as "theme-referall", _11 as "theme-sleep", _12 as "theme-white-theme", _13 as "theme-xyz" }
